"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiDialogContentText = void 0;
var palette_1 = require("../../global/palette");
exports.MuiDialogContentText = {
    root: {
        color: palette_1.palette.grey[800],
        '&:last-child': {
            marginBottom: 0,
        },
    },
};
